import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from "@angular/material/snack-bar";
import { ShowSnackbarArgs } from "@modules/common/models/show-snackbar-args";

@Injectable({
    providedIn: 'root'
})
export class SnackbarService {
    constructor(private _matSnackBar: MatSnackBar) { }

    public open(args: ShowSnackbarArgs): MatSnackBarRef<TextOnlySnackBar> {
        return this._matSnackBar.open(args.message, args.action || 'GOT IT', {
            duration: args.duration || 60000
        });
    }
}
